module.exports = __webpack_public_path__ + "static/img/business16.0efcf31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business16.jpg
// module id = veHt
// module chunks = 9